import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './components/Home';
import MeetAlicia from './components/MeetAlicia';
import MyApproach from './components/MyApproach';
import Services from './components/Services';
import AreasOfFocus from './components/AreasOfFocus';
import Grief from './components/Grief';
import Dreams from './components/Dreams';
import SpiritualIntegration from './components/SpiritualIntegration';
import Resources from './components/Resources';
import FAQs from './components/FAQs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/meet-alicia" element={<MeetAlicia />} />
            <Route path="/my-approach" element={<MyApproach />} />
            <Route path="/services" element={<Services />} />
            <Route path="/areas-of-focus" element={<AreasOfFocus />} />
            <Route path="/areas-of-focus/grief" element={<Grief />} />
            <Route path="/areas-of-focus/dreams" element={<Dreams />} />
            <Route path="/areas-of-focus/spiritual-integration" element={<SpiritualIntegration />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
